export default "__VITE_ASSET__1996ad9d__"